import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-500">编辑团队为你精选的优质内容</p>
          </div>
          <Link
            to="/category/latest-promotions"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <span className="flex items-center gap-1 text-primary-500 group-hover:translate-x-0.5 transition-transform">
                    阅读
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-promotions"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}